export default __webpack_public_path__ + "static/media/tarima9.d0d95f00.png";